import React from "react";
import { motion } from "framer-motion";
import PianoScene from "./PianoScene";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen w-full overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <PianoScene />
      </div>

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 35% 50%, rgba(229,115,36,0.18) 0%, rgba(8,6,5,0) 50%)",
        }}
      />

      {/* Content overlay */}
      <div className="relative z-10 min-h-screen flex flex-col justify-end items-end pb-12 md:pb-20 lg:pb-24 pt-32 px-6 md:pr-12 lg:pr-12">
        <div className="max-w-[560px] text-left flex flex-col">
          {/* Eyebrow — desktop above title (order-1), mobile below title (order-3) */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.3 }}
            className="eyebrow mb-4 md:mb-5 order-2 md:order-1 mt-3 md:mt-0"
            data-testid="hero-eyebrow"
            style={{ textShadow: "0 2px 12px rgba(0,0,0,0.9)" }}
          >
            · Концерт-моноспектакль при свечах ·
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.4, delay: 0.5, ease: [0.2, 0.8, 0.2, 1] }}
            className="font-serif font-light tracking-tight leading-[0.95] flicker order-1 md:order-2"
            style={{
              fontSize: "clamp(2.8rem, 6vw, 5.5rem)",
              color: "#F2E9DE",
              textShadow: "0 4px 50px rgba(0,0,0,0.95)",
            }}
            data-testid="hero-title"
          >
            Вечные
            <br />
            <span style={{ fontStyle: "italic", color: "#E57324" }}>
              Шопен
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1 }}
            className="mt-5 max-w-xl font-light text-sm lg:text-base leading-relaxed tracking-wide order-3 md:order-3"
            style={{ color: "#F2E9DE", textShadow: "0 2px 18px rgba(0,0,0,0.95)" }}
            data-testid="hero-subtitle"
          >
            Путешествие в душу Фридерика Шопена в сиянии свечей. Его бессмертные сочинения, сплетённые с историей жизни, в исполнении{" "}
            <span style={{ color: "#FFB84D" }}>Вероники Валовой</span>.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.3 }}
            className="mt-7 flex flex-row flex-nowrap items-center gap-5 order-4"
          >
            <a
              href="#fechas"
              className="btn-primary"
              data-testid="hero-cta-tickets"
            >
              Билеты
            </a>
            <a
              href="#entradas"
              className="btn-ghost whitespace-nowrap"
              data-testid="hero-cta-show"
            >
              СКИДКА 20% →
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
